import {
  Area,
  CartesianGrid,
  ComposedChart,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { crisisTrend, valueImpactMetrics } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function CrisisTrend() {
  return (
    <section id="crisis" className="w-full border-b border-background-200 bg-background-50 py-10 md:py-14">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHeading
          no="05"
          title="公关危机与商业价值影响"
          desc="把热度曲线和商业价值指标放在一起看：热度会在几天内回落，但它对转化、经销商信心与话题构成的拖尾，往往更值得盯。"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* chart */}
          <div className="rounded-lg border border-background-200 bg-background-100/50 p-4 md:p-6 lg:col-span-8">
            <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
              <h4 className="font-heading text-base font-bold text-foreground-950">近 8 日舆情热度走势</h4>
              <div className="flex items-center gap-4 text-[11px] text-foreground-600">
                <span className="flex items-center gap-1.5">
                  <span className="h-2.5 w-2.5 rounded-sm bg-primary-500"></span>
                  危机热度
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="h-0.5 w-4 rounded-full bg-accent-500"></span>
                  商业价值指数
                </span>
              </div>
            </div>

            <div className="h-64 w-full md:h-72">
              <ResponsiveContainer width="100%" height="100%">
                <ComposedChart data={crisisTrend} margin={{ top: 6, right: 8, left: -18, bottom: 0 }}>
                  <defs>
                    <linearGradient id="heatFill" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="oklch(var(--primary-500))" stopOpacity={0.45} />
                      <stop offset="95%" stopColor="oklch(var(--primary-500))" stopOpacity={0.02} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" stroke="oklch(var(--background-300))" vertical={false} />
                  <XAxis
                    dataKey="day"
                    tick={{ fontSize: 11, fill: "oklch(var(--foreground-500))" }}
                    axisLine={false}
                    tickLine={false}
                  />
                  <YAxis
                    tick={{ fontSize: 11, fill: "oklch(var(--foreground-500))" }}
                    axisLine={false}
                    tickLine={false}
                  />
                  <Tooltip
                    contentStyle={{
                      borderRadius: "8px",
                      border: "1px solid oklch(var(--background-300))",
                      background: "oklch(var(--background-50))",
                      fontSize: "12px",
                      color: "oklch(var(--foreground-950))",
                    }}
                  />
                  <Area
                    type="monotone"
                    dataKey="heat"
                    name="危机热度"
                    stroke="oklch(var(--primary-500))"
                    strokeWidth={2}
                    fill="url(#heatFill)"
                  />
                  <Line
                    type="monotone"
                    dataKey="value"
                    name="商业价值指数"
                    stroke="oklch(var(--accent-600))"
                    strokeWidth={2}
                    dot={{ r: 3, fill: "oklch(var(--accent-600))" }}
                    activeDot={{ r: 5 }}
                  />
                </ComposedChart>
              </ResponsiveContainer>
            </div>
          </div>

          {/* metrics */}
          <div className="lg:col-span-4">
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-1">
              {valueImpactMetrics.map((m) => (
                <div
                  key={m.label}
                  className="flex items-center justify-between rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <div>
                    <p className="text-xs text-foreground-600">{m.label}</p>
                    <p className="mt-1 flex items-baseline gap-1">
                      <span className="font-heading text-2xl font-black text-foreground-950">{m.value}</span>
                      <span className="text-xs text-foreground-500">{m.unit}</span>
                    </p>
                  </div>
                  <span className="flex items-center gap-0.5 rounded-full bg-primary-50 px-2 py-1 text-[11px] font-semibold text-primary-600">
                    <i className="ri-arrow-up-line w-3 h-3 flex items-center justify-center"></i>
                    {m.delta}
                  </span>
                </div>
              ))}
            </div>
            <p className="mt-3 flex items-center gap-2 text-[11px] text-foreground-500">
              <i className="ri-database-2-line w-4 h-4 flex items-center justify-center"></i>
              指标为公开信息聚合后的相对值，仅用于趋势参考。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}